export enum AppMultipleSelectionBarButtonIcon {
  'delete' = 'delete'
}
